var React = require('react');

function BoxRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Kawa","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"kawa-","transform":"translate(-917.000000, -6191.000000)","fill":"#F5CFC7"},React.createElement("g",{"id":"Group-22","transform":"translate(157.000000, 6163.000000)"},React.createElement("polygon",{"id":"Rectangle-Copy-3","points":"760 28.779541 1094 28.779541 1105 283.809204 760 252"})))));
}

BoxRight.defaultProps = {"preserveAspectRatio":"none","width":"345px","height":"256px","viewBox":"0 0 345 256","version":"1.1"};

module.exports = BoxRight;

BoxRight.default = BoxRight;
